export const INVITE_MANY_EMPLOYEES_WIZARD_NAMESPACE = 'invite-many-employees';

export const INVITE_MANY_STEPS = {
  EMPLOYEES_SELECTION: 'employees-selection',
  INVITATION_RECAP: 'invitation-recap',
} as const;
